var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"footer",attrs:{"fluid":""}},[_c('icon-base',{attrs:{"icon-name":"truetzschler","width":"115","height":"25","viewBox":"0 0 115 25"}},[_c('icon-truetzschler',{attrs:{"fill":"#B7B7B7"}})],1),_c('div',{staticClass:"version-number"},[_vm._v("Version: "+_vm._s(_vm.buildNumber))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }